import {
  fetchRailsStart,
  fetchRailsSuccess,
  fetchRailsFailure,
  fetchRailGpsDataStart,
  fetchRailGpsDataSuccess,
  fetchRailGpsDataFailure,
  submitRailDataStart,
  submitRailDataSuccess,
  submitRailDataFailure,
} from './rails.slice';

import { getRailsForDrive, getRailGpsData, submitRailData } from '../api/rail.api';

// Fetch rails for a drive
const fetchRails = (driveId) => async (dispatch) => {
  dispatch(fetchRailsStart());
  try {
    const response = await getRailsForDrive(driveId);
    // Handle axios response structure: response.data = { status, data: { driveId, rails: [...] } }
    const railsData = response.data?.data?.rails || response.data?.rails || response.data || [];
    // Ensure it's an array
    const railsArray = Array.isArray(railsData) ? railsData : [];
    dispatch(fetchRailsSuccess(railsArray));
    // also fetch the rail gps details endpoint and merge/adapt into state
    dispatch(fetchRailGpsData(driveId));
  } catch (error) {
    dispatch(fetchRailsFailure(error.message || 'Failed to fetch rails'));
  }
};

// Fetch GPS data for rails
const fetchRailGpsData = (driveId) => async (dispatch) => {
  dispatch(fetchRailGpsDataStart());
  try {
    const response = await getRailGpsData(driveId);
    // Handle axios response structure: response.data = { status, data: { driveId, rails: [...] } }
    const gpsData = response.data?.data?.rails || response.data?.rails || response.data || [];
    dispatch(fetchRailGpsDataSuccess(gpsData));
  } catch (error) {
    dispatch(fetchRailGpsDataFailure(error.message || 'Failed to fetch rail GPS data'));
  }
};

// Submit rail data
const submitRailDataAction = (data) => async (dispatch) => {
  dispatch(submitRailDataStart());
  try {
    const result = await submitRailData(data);
    dispatch(submitRailDataSuccess(result));
  } catch (error) {
    dispatch(submitRailDataFailure(error.message || 'Failed to submit data'));
  }
};

export { fetchRails, fetchRailGpsData, submitRailDataAction };
